export default "/build/images/unionpay.5c3adaa8.png";